import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-taxes';

export default function Example() {
  return (
    <>
      <Head>
        <title>Navigating eBay taxes: The basics to get you started</title>
        <meta
          name='description'
          content='Should I charge sales tax on eBay? How much does a buyer pay for eBay tax? This primer helps you understand the applicable tax laws and your responsibilities as a seller in complying with them.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-taxes' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-taxes' />
        <meta property='og:title' content='Navigating eBay taxes: The basics to get you started' />
        <meta
          property='og:description'
          content='Should I charge sales tax on eBay? How much does a buyer pay for eBay tax? This primer helps you understand the applicable tax laws and your responsibilities as a seller in complying with them.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='April 14th, 2022' />
        <meta property='article:modified_time' content='April 14th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
